import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "utility-nav__search__form" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["placeholder", "onKeydown"]

import { ref, nextTick, onMounted, onUnmounted } from 'vue'
import useLoader from '../../composables/useLoader'
import useForm from '../../composables/useForm'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


const __default__ = {
  name: 'UtilityNavigationSearch',
  components: {
    FontAwesomeIcon,
  },
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const mobileBreakpoint = 1024
const { setLoading } = useLoader()
const { isBusy } = useForm()
const showForm = ref(false)
const searchQuery = ref('')
const headerSearchInput = ref(null)
const headerSearchIcon = ref(null)
const isMobile = ref(false)
const headerSearchInputContainer = ref(null)

/**
 * Handles the search form submission
 */
const handleSearch = (): void => {
  isBusy.value = true
  setLoading(true)

  const searchInputName = process.env.ELASTICSEARCH_RM_INDEX + '[query]' ?? ''
  window.location.href =
    '/search?' + searchInputName + '=' + encodeURIComponent(searchQuery.value)
}

/**
 * Handles showing and focusing the search form
 */
const showSearch = async (): Promise<void> => {
  setTimeout(() => {
    showForm.value = true

    const input = document.getElementById('search_query') as HTMLInputElement
    if (input) input.focus()
  }, 100)
}

/**
 * Handles closing the search form and focusing the toggle button
 */
const closeSearch = async (): Promise<void> => {
  showForm.value = false

  await nextTick()

  const button = document.querySelector(
    'button.utility-nav__search__toggle',
  ) as HTMLButtonElement

  if (button) {
    button.focus()
  }
}

/**
 * Toggles the search form visibility
 */
const toggleSearch = (event) => {
  if (showForm.value) {
    closeSearch()
  } else {
    showSearch()
  }
}

/**
 * Handles the click event outside of the search form to close it
 */
const handleClickOutside = (event) => {
  let hideSearch = false
  if (showForm.value) {
    if (
      headerSearchInputContainer.value &&
      !headerSearchInputContainer.value.contains(event.target)
    ) {
      showForm.value = false
    }
  }
}

/**
 * Handles the resize event to determine if the viewport is mobile or not
 */
const handleResize = () => {
  if (window.innerWidth < mobileBreakpoint) {
    isMobile.value = true
  } else {
    isMobile.value = false
  }
}

/**
 * Handles closing the search form when the user scrolls on mobile
 */
const handleScroll = () => {
  if (isMobile.value && showForm.value) {
    showForm.value = false
  }
}

onMounted(() => {
  handleResize()
  // Set event listeners
  window.addEventListener('resize', handleResize)
  window.addEventListener('scroll', handleScroll)
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  // Cleanup event listeners
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('scroll', handleScroll)
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "headerSearchInputContainer",
    ref: headerSearchInputContainer,
    class: _normalizeClass(['search--global', { active: showForm.value }])
  }, [
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("label", {
        for: "search_query",
        class: "sr-only",
        textContent: _toDisplayString('Search this site')
      }, null, 8, _hoisted_2),
      _withDirectives(_createElementVNode("input", {
        id: "search_query",
        ref_key: "headerSearchInput",
        ref: headerSearchInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
        type: "text",
        name: "search_query",
        class: "utility-nav__search__form-input",
        placeholder: isMobile.value ? 'Search' : 'Enter to search...',
        onKeydown: [
          _withKeys(closeSearch, ["esc"]),
          _withKeys(_withModifiers(handleSearch, ["prevent"]), ["enter"])
        ]
      }, null, 40, _hoisted_3), [
        [_vModelText, searchQuery.value]
      ]),
      _createElementVNode("button", {
        ref_key: "headerSearchIcon",
        ref: headerSearchIcon,
        type: "button",
        class: "utility-nav__search__toggle__inset",
        onClick: handleSearch
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'search'] })
      ], 512),
      (isMobile.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "utility-nav__search__form-close",
            "aria-label": "Close Search",
            onClick: closeSearch
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'times'] })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      ref_key: "headerSearchIcon",
      ref: headerSearchIcon,
      class: "utility-nav__search__toggle",
      onClick: toggleSearch
    }, [
      _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'search'] })
    ], 512)
  ], 2))
}
}

})